// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#aw--c #aw-sl .pw-player-poster>img{width:100%!important;height:100%!important}#aw--c #aw-sl .pw-player-poster{display:-webkit-box!important;display:-ms-flexbox!important;display:flex!important;z-index:3!important;background-color:transparent!important}", ""]);
// Exports
module.exports = exports;
